module.exports = __webpack_public_path__ + "static/media/golf.67966cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/golf.jpg
// module id = 1131
// module chunks = 0